module.exports = __webpack_public_path__ + "static/img/icon_vegetable.png";